export default __webpack_public_path__ + "src/docs/packages/zannier-hotels-omaanda.pdf";